var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flickity',{directives:[{name:"images-loaded",rawName:"v-images-loaded:on.progress",value:(_vm.layout),expression:"layout",arg:"on",modifiers:{"progress":true}}],ref:_vm.myRef,staticClass:"flickity",attrs:{"options":_vm.options}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9eee4c34","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FlickityBox.vue
// module id = null
// module chunks = 